<template>
  <div>
    <ag-grid-vue
      style="height: 800px"
      class="ag-theme-alpine"
      ref="table"
      :pagination="true"
      :paginationPageSize="300"
      :rowData="rowData"
      :columnDefs="columnDefs"
      :localeText="localText"
    >
    </ag-grid-vue>
  </div>
</template>

<script>
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";
import gridLocale from "@/components/local-services/sub-components/agGridLocale.uk.js";
export default {
  props: ["rowData"],
  components: {
    AgGridVue,
  },
  data() {
    return {
      columnDefs: null,
      localText: gridLocale,
    };
  },
  methods: {},
  beforeMount() {
    this.columnDefs = [
      {
        field: "number",
        headerName: "№",
        width: 80,
        sortable: true,
        sort: "asc",
        type: "numericColumn",
        comparator: function (valueA, valueB) {
          return Number(valueA) == Number(valueB)
            ? 0
            : Number(valueA) > Number(valueB)
            ? 1
            : -1;
        },
      },
      {
        headerName: "П.І.П.",
        field: "name",
        resizable: true,
        sortable: true,
        width: 500,
        filter: "agTextColumnFilter",
      },

      {
        field: "privilege",
        headerName: "Причина",
        width: 600,
        resizable: true,
      },
    ];
  },
};
</script>

<style lang="scss" scoped></style>
